import { useState, useEffect } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      src: 'https://static.wixstatic.com/media/288b4c_dd5ca6febbd04c31acfca26f81841ce2~mv2.jpg/v1/fill/w_265,h_352,al_c,q_80,usm_0.66_1.00_0.01/288b4c_dd5ca6febbd04c31acfca26f81841ce2~mv2.jpg',
      title: 'Bathroom Update',
    },
    {
      src: 'https://static.wixstatic.com/media/288b4c_002140ef5d9e45e583ddfe7c98963115~mv2.jpg/v1/fill/w_568,h_427,al_c,q_80,usm_0.66_1.00_0.01/288b4c_002140ef5d9e45e583ddfe7c98963115~mv2.jpg',
      title: 'Flooring',
    },
    {
      src: 'https://static.wixstatic.com/media/288b4c_8eeef4652c1e4c08ab4a28aa445bef7e~mv2.jpg/v1/fill/w_264,h_352,al_c,q_80,usm_0.66_1.00_0.01/288b4c_8eeef4652c1e4c08ab4a28aa445bef7e~mv2.jpg',
      title: 'Kitchen Remodel',
    },
    {
      src: 'https://static.wixstatic.com/media/288b4c_37c307b208e24802a19e2e809e182427~mv2.jpg/v1/fill/w_265,h_352,al_c,q_80,usm_0.66_1.00_0.01/288b4c_37c307b208e24802a19e2e809e182427~mv2.jpg',
      title: 'Bathroom Renovation',
    },
    {
      src: 'https://static.wixstatic.com/media/288b4c_f4006167233f4bf3a6b2fa81871c7849~mv2.jpg/v1/fill/w_265,h_352,al_c,q_80,usm_0.66_1.00_0.01/288b4c_f4006167233f4bf3a6b2fa81871c7849~mv2.jpg',
      title: 'Cantilever and Carport',
    },
    {
      src: 'https://static.wixstatic.com/media/288b4c_34e93c1086f34dc79522aa33d3180b0e~mv2.jpeg/v1/fill/w_568,h_318,al_c,q_80,usm_0.66_1.00_0.01/288b4c_34e93c1086f34dc79522aa33d3180b0e~mv2.jpeg',
      title: 'Interior Transformation',
    },
    {
      src: 'https://static.wixstatic.com/media/288b4c_e3f6fc496fc0465fb599e62275f34988~mv2.jpeg/v1/fill/w_568,h_378,al_c,q_80,usm_0.66_1.00_0.01/288b4c_e3f6fc496fc0465fb599e62275f34988~mv2.jpeg',
      title: 'Deck and Landing',
    },
    {
      src: 'https://static.readdy.ai/image/d18859bc617732e326735d9a6df55c85/ed3264297178bb2bf9b36fc2f598a1be.jpeg',
      title: 'Commercial Project',
    },
    {
      src: 'https://static.readdy.ai/image/d18859bc617732e326735d9a6df55c85/0331a7148fc56e5b317ad2b26ff987e1.jpeg',
      title: 'Cafe Reception Build',
    },
  ];

  // Auto-cycle effect for desktop
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [images.length]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const getVisibleImages = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      visible.push(images[(currentIndex + i) % images.length]);
    }
    return visible;
  };

  return (
    <>
      <section id="portfolio" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Portfolio</h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto mb-4"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Explore our recent projects showcasing quality craftsmanship and attention to detail
            </p>
          </div>

          {/* Desktop: 3-image carousel */}
          <div className="hidden md:block relative max-w-6xl mx-auto">
            <div className="relative overflow-hidden">
              <div className="grid grid-cols-3 gap-6">
                {getVisibleImages().map((image, index) => (
                  <div
                    key={`${currentIndex}-${index}`}
                    className="group relative h-96 rounded-xl overflow-hidden shadow-lg cursor-pointer transition-transform hover:scale-105"
                    onClick={() => setSelectedImage(image.src)}
                  >
                    <img
                      src={image.src}
                      alt={image.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <h3 className="text-white text-lg font-bold">{image.title}</h3>
                    </div>
                  </div>
                ))}
              </div>

              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer z-10"
              >
                <i className="ri-arrow-left-s-line text-2xl"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer z-10"
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </button>
            </div>

            <div className="flex justify-center mt-6 gap-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`transition-all cursor-pointer rounded-full ${
                    index === currentIndex
                      ? 'w-8 h-2.5 bg-orange-500'
                      : 'w-2.5 h-2.5 bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Mobile: Single image carousel */}
          <div className="md:hidden relative max-w-5xl mx-auto">
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-700 ${
                    index === currentIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={image.src}
                    alt={image.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white text-2xl font-bold">{image.title}</h3>
                  </div>
                </div>
              ))}

              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-2xl"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </button>
            </div>

            <div className="flex justify-center mt-6 gap-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`transition-all cursor-pointer rounded-full ${
                    index === currentIndex
                      ? 'w-8 h-2.5 bg-orange-500'
                      : 'w-2.5 h-2.5 bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white text-4xl hover:text-orange-500 transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={selectedImage}
            alt="Gallery"
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
    </>
  );
}
